import { render, staticRenderFns } from "./B2BOrderModal.vue?vue&type=template&id=0306097e"
import script from "./B2BOrderModal.vue?vue&type=script&lang=js"
export * from "./B2BOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports